import { includes } from 'lodash'
import { computed, makeObservable } from 'mobx'

import { Collection } from 'modules/core/lib/mobx-rest'

import getTitle from 'modules/documents/components/Documents/getTitle'
import Folder, { ALL_TYPES } from 'modules/documents/store/models/Folder'

export class Folders extends Collection<Folder> {
  constructor(data: any = []) {
    super(data)
    makeObservable(this, {
      contractFolder: computed,
      payrollExportsFolder: computed,
      sickFolder: computed,
      expensesFolders: computed,
    })
  }

  get indexes() {
    return ['url', 'is_employee']
  }

  get contractFolder(): Folder | null | undefined {
    return this.find({
      type: 'contract',
    })
  }

  get payrollExportsFolder(): Folder | null | undefined {
    return this.find({
      type: 'payroll_exports',
    })
  }

  get sickFolder(): Folder | null | undefined {
    return this.find({
      type: 'sick-leave',
    })
  }

  get expensesFolders(): Folder[] {
    const expensesTypes = [ALL_TYPES.expenses_employee, ALL_TYPES.expenses_company]

    return this.models.filter((folder: Folder) => includes(expensesTypes, folder.type))
  }

  get writableFolders(): Folder[] {
    return this.models.filter((folder: Folder) => {
      return (
        folder.attributes.type !== ALL_TYPES.sick_leave &&
        !folder.showOnly &&
        folder.attributes.manage_permission
      )
    })
  }

  static toOptions(folders: Folder[]) {
    const sortedFolders = sortFoldersByRoot(folders)

    return sortedFolders.map((folder: Folder) => ({
      label: getFolderOptionTitle(folder),
      value: folder.attributes.id,
    }))
  }

  model() {
    return Folder
  }
}

function sortFoldersByRoot(folders: Folder[]) {
  const rootFolders = folders.filter((folder) => !folder.attributes.parent_folder_id)
  const subfolders = folders.filter((folder) => !rootFolders.includes(folder))

  const sortedFolders: Folder[] = []

  rootFolders.forEach((rootFolder) => {
    sortedFolders.push(rootFolder)
    sortedFolders.push(
      ...subfolders.filter(
        (folder) => folder.attributes.root_parent_folder_id === rootFolder.attributes.id
      )
    )
  })

  return sortedFolders
}

function getFolderOptionTitle(folder: Folder): string {
  const title = getTitle(folder.attributes.name)
  const prefix = '↳ '

  return folder.attributes.parent_folder_id ? prefix + title : title
}

const singleton: Folders = new Folders()

export default singleton
